import {
  GET_SUPPLY_NOTES,
  OPEN_MODAL_SUPPLY_NOTES,
  CLOSE_MODAL_SUPPLY_NOTES,
} from "redux/reducers/supplyNotes/supplyNotesReducer";
import { setSnackbar, startRequest, stopRequest } from "redux/actions/search/searchActions";
import { api_get, PROYECT } from "services/api";

const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}`;

export const getSupplyNotes = (station, startDate, endDate) => {
  const url = `${mainUrl}/notes/locations?start=${startDate}&end=${endDate}&idStation=${station}`;
  return async (dispatch) => {
    dispatch(startRequest());
    await api_get(url).then(resp => {
      dispatch({ type: GET_SUPPLY_NOTES, payload: resp });
    }).catch(err => {
      const message = err ? err : "Error en la solicitud";
      dispatch(setSnackbar(message));
    });
    dispatch(stopRequest());
  };
};

export const openModal = (supplyNote) => {
  return { type: OPEN_MODAL_SUPPLY_NOTES, payload: supplyNote };
};

export const closeModal = () => {
  return { type: CLOSE_MODAL_SUPPLY_NOTES };
};
